import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import MediaCard from './MediaCard';
import ClientProvider from './client';
export default createDemo(import.meta.url, MediaCard, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/cards/demos/media/MediaCard.tsx",
    "fileName": "MediaCard.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Card from '@mui/material/Card';\nimport CardActions from '@mui/material/CardActions';\nimport CardContent from '@mui/material/CardContent';\nimport CardMedia from '@mui/material/CardMedia';\nimport Button from '@mui/material/Button';\nimport Typography from '@mui/material/Typography';\n\nexport default function MediaCard() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Card sx={{ maxWidth: 345 }}>\n      <CardMedia\n        sx={{ height: 140 }}\n        image=\"/static/images/cards/contemplative-reptile.jpg\"\n        title=\"green iguana\"\n      />\n      <CardContent>\n        <Typography gutterBottom variant=\"h5\" component=\"div\">\n          Lizard\n        </Typography>\n        <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n          Lizards are a widespread group of squamate reptiles, with over 6,000\n          species, ranging across all continents except Antarctica\n        </Typography>\n      </CardContent>\n      <CardActions>\n        <Button size=\"small\">Share</Button>\n        <Button size=\"small\">Learn More</Button>\n      </CardActions>\n    </Card>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 31,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Card from '@mui/material/Card';\nimport CardActions from '@mui/material/CardActions';\nimport CardContent from '@mui/material/CardContent';\nimport CardMedia from '@mui/material/CardMedia';\nimport Button from '@mui/material/Button';\nimport Typography from '@mui/material/Typography';\n\nexport default function MediaCard() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Card sx={{ maxWidth: 345 }}>\n      <CardMedia\n        sx={{ height: 140 }}\n        image=\"/static/images/cards/contemplative-reptile.jpg\"\n        title=\"green iguana\"\n      />\n      <CardContent>\n        <Typography gutterBottom variant=\"h5\" component=\"div\">\n          Lizard\n        </Typography>\n        <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n          Lizards are a widespread group of squamate reptiles, with over 6,000\n          species, ranging across all continents except Antarctica\n        </Typography>\n      </CardContent>\n      <CardActions>\n        <Button size=\"small\">Share</Button>\n        <Button size=\"small\">Learn More</Button>\n      </CardActions>\n    </Card>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 31,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Card",
      "@mui/material/CardActions",
      "@mui/material/CardContent",
      "@mui/material/CardMedia",
      "@mui/material/Button",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
